<template>
  <a-drawer
    :visible="visible"
    title="添加嘱托"
    :closable="true"
    placement="right"
    :width="500"
    @close="handleCancel"
  >
    <div class="advice-modal">
      <div class="advice-modal__section">
        <div class="advice-modal__label">用药禁忌</div>
        <div class="advice-modal__options">
          <a-button
            class="advice-modal__chip"
            :type="localSelected.includes('无禁忌') ? 'primary' : 'default'"
            @click="toggleOption('无禁忌')"
          >
            无禁忌
          </a-button>
          <a-button
            v-for="(option, index) in remoteOptions"
            :key="option.dictValue || index"
            class="advice-modal__chip"
            :type="localSelected.includes(option.dictValue) ? 'primary' : 'default'"
            @click="toggleOption(option.dictValue)"
          >
            {{ option.dictValue }}
          </a-button>
        </div>
      </div>
      <div class="advice-modal__section">
        <div class="advice-modal__label">用药说明</div>
        <a-textarea
          v-model:value="localAdvice"
          placeholder="请填写用药说明"
          :maxlength="100"
          showCount
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </div>
    </div>
    <div class="advice-modal__footer">
      <a-button @click="handleCancel" style="margin-right: 8px">取消</a-button>
      <a-button type="primary" @click="handleConfirm">确定</a-button>
    </div>
  </a-drawer>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { useStore } from 'vuex'
import { getDictByType } from '@/api/HealthRecord'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  selected: {
    type: Array,
    default: () => []
  },
  advice: {
    type: String,
    default: ''
  }
})

const emit = defineEmits([
  'update:visible',
  'update:selected',
  'update:advice',
  'confirm',
  'cancel'
])

const store = useStore()

const localSelected = ref([])
const localAdvice = ref('')
const remoteOptions = ref([])
const isLoading = ref(false)

const fetchOptions = async () => {
  if (isLoading.value) return
  isLoading.value = true
  try {
    const params = {
      doctorId: store.state.preMedicalRecord?.doctorId ?? null,
      dictType: 'WESTERN_MEDICINE_USE_TABOO_DICT'
    }
    const res = await getDictByType(params)
    remoteOptions.value = Array.isArray(res) ? res : res?.data || []
  } catch (error) {
    remoteOptions.value = []
  } finally {
    isLoading.value = false
  }
}

watch(
  () => props.visible,
  visible => {
    if (visible) {
      localSelected.value = Array.isArray(props.selected) ? [...props.selected] : []
      localAdvice.value = props.advice || ''
      fetchOptions()
    }
  },
  { immediate: true }
)

watch(
  () => localSelected.value,
  value => {
    emit('update:selected', value)
  },
  { deep: true }
)

watch(
  () => localAdvice.value,
  value => {
    emit('update:advice', value)
  }
)

const toggleOption = value => {
  const isNone = value === '无禁忌'
  if (isNone) {
    localSelected.value = ['无禁忌']
    return
  }
  const next = new Set(localSelected.value)
  next.delete('无禁忌')
  if (next.has(value)) {
    next.delete(value)
  } else {
    next.add(value)
  }
  localSelected.value = Array.from(next)
}

const handleConfirm = () => {
  emit('confirm')
  emit('update:visible', false)
}

const handleCancel = () => {
  emit('cancel')
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.advice-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.advice-modal__section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.advice-modal__label {
  font-size: 14px;
  color: #1f1f1f;
}

.advice-modal__options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.advice-modal__chip {
  border-radius: 16px;
}

.advice-modal__footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
